var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFaWater(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_111_5249)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.571 19.1559C22.908 15.2769 22.344 10.2019 19.063 6.91992L12 0.013916L6.65497 5.24092L1.45697 0.042916L0.0429688 1.45692L22.543 23.9569L23.957 22.5429L20.571 19.1559ZM12 2.81092L17.657 8.34292C20.155 10.8419 20.681 14.6489 19.102 17.6879L8.06897 6.65492L11.999 2.81092H12ZM16.426 20.6679L17.862 22.1039C16.167 23.3349 14.135 23.9999 12.001 23.9999C9.32997 23.9999 6.81897 22.9599 4.92997 21.0709C1.41197 17.5529 1.06797 12.0459 3.89797 8.13892L5.33397 9.57492C3.27197 12.6759 3.60697 16.9199 6.34397 19.6569C7.85497 21.1679 9.86497 21.9999 12.001 21.9999C13.599 21.9999 15.126 21.5339 16.426 20.6679Z",
    fill: "#0E4945"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_111_5249"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaWater);
export default __webpack_public_path__ + "static/media/faWater.1d9bc19476384e2976749a3cdd76c011.svg";
export { ForwardRef as ReactComponent };